import React from 'react';

import MainContent from '../../components/MainContent';
import Navbar from '../../components/Navbar';
import Overlay from '../../components/Overlay';
import SideBar from '../../components/SideBar';
import { SidebarProvider } from '../../contexts/sidebar';

const Layout: React.FC = () => {
  return (
    <SidebarProvider>
      <Overlay />

      <Navbar />
      <MainContent />
      <SideBar />
    </SidebarProvider>
  );
};

export default Layout;
